export default "__VITE_ASSET__b54f6224__"